import { createAsyncThunk } from "@reduxjs/toolkit"
import { getRequest, getRequestPerEnv } from "../utils/GetRequest";
import { userObject } from "../../model/user-object/UserObject.model";
import { RootState } from "../../root-redux/RootState";
import { SPA_ENT_APPROVER_GROUP_MAIL, SPA_SMC_APPROVER_GROUP_MAIL } from "../../feature-components/spa-admin/SPAConstants";

export const getAllSPAUserObjects = createAsyncThunk<userObject[], string[], { state: RootState }>('campaignUserObjects/getuserobjects', async (obectIds: string[], { getState }) => {
    const env = getState().env.selectedEnvItem;
    var domain = env === 'dev' || env === 'uat' ? 'predictions' : 'audit';
    const response = await getRequestPerEnv<userObject[]>(`${domain}/userobjects?objectIds=${obectIds.join(",")}`, env);
    return response.data
});

export const getApproverObjectByIdOrName = createAsyncThunk<userObject[], string, { state: RootState }>('campaignUserObjects/getuserobjectbyid', async (objectId: string, { getState }) => {
    const env = getState().env.selectedEnvItem;
    var domain = env === 'dev' || env === 'uat' ? 'predictions' : 'audit';
    const response = await getRequestPerEnv<userObject[]>(`${domain}/userobjects?objectIds=${objectId}`, env);
    return response.data
});

export const getEnterpriseApprovers = createAsyncThunk<userObject[], void, { state: RootState }>(
    'campaignUserObjects/getEnterpriseApprovers',
    async (_, { getState }) => {
        const env = getState().env.selectedEnvItem;
        
        // Get enterprise approvers based on roles and segment
        const response = await getRequest<userObject[]>(
            `uat/campaigns/groups/members/${SPA_ENT_APPROVER_GROUP_MAIL}`
        );
        
        return response.data;
    }
);

export const getSMCApprovers = createAsyncThunk<userObject[], void, { state: RootState }>(
    'campaignUserObjects/getSMCApprovers',
    async (_, { getState }) => {
        const env = getState().env.selectedEnvItem;
        const domain = env === 'dev' || env === 'uat' ? 'predictions' : 'audit';
        
        // Get SMC approvers based on roles and segment
        const response = await getRequest<userObject[]>(
            `uat/campaigns/groups/members/${SPA_SMC_APPROVER_GROUP_MAIL}`
        );
        
        return response.data;
    }
)